import React from "react";
import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

const FullScreenModal = ({ isOpen, onClose, children, styleClass }) => {
  return (
    <div>
      {isOpen && (
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          transition={{ duration: 0.5 }}
          className={twMerge("fixed top-0 z-[100] left-0 w-screen min-h-screen bg-black bg-opacity-50 flex justify-center items-center", styleClass)}
        >
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-[#402A6A] rounded-lg shadow-lg w-full w-screen min-h-screen "
          >
            <div className="p-4 bg-gray-300 flex justify-start">
              <button onClick={onClose} className="text-black hover:text-gray-800 focus:outline-none">
                Close
              </button>
            </div>
            <div className="p-6 ">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default FullScreenModal;
